import React from 'react';
import { useEffect, useRef, useState } from 'react';
import { IQuery, RESPONSE_BY } from '../../../models/IQueryType';
import SendMessage from '../../openAIChat/SendMessage';
import ChatReply from '../../openAIChat/ChatReply';
import InputBox from '../../openAIChat/InputBox';
import LABELS from '../../../ui-constants/en.json';
import { useDispatch, useSelector } from 'react-redux';
import { HttpStatusCode } from '../../../ui-constants/base/enum';
import { IStore } from '../../../store';
import {
  setChatHistory,
  setChatSummary,
  setChunkLoading,
  setWhoelChatTable,
  toggleLoader,
  clearDownloadFileMessage,
  setDownloadFileMessageWord,
  setRelevantFiles,
  setChatTable,
  setChatErrors,
  regenerateChatSummary,
  saveUserChatThreadHistory,
  setLastDeletedThreadID,
  setDownloadNSuggestion,
  setFinalChatsummary,
  lastExecutedMessage,
  clearChatHistory,
  setLastSavedThreadID,
  setSelectedChatThread
} from '../../../store/actions/userChatActions';
import LinkButton from '../../LinkButton/LinkButton';
import { downloadImg, stopChatIcon } from '../../../commonImage';
import exportToCombinedDoc from '../../openAIChat/utils/exportToCombinedDoc';
import './CombinedMarketChat.scss';
import {
  getCIQueryResponse,
  saveDownloadChatActivity,
  saveUserChatHistory
} from '../../../services/chatQuery.service';
import {
  checkOnySpecialCharacter,
  getComputedRequestObject,
  handleSessionID,
  handleUserChatThreadHistory,
  setThreadsUnSelected,
  extractSources
} from '../../../utils/commonUtils';
import { initializeSession } from '../../../services/session.service';
import errorStatus from '../../../utils/ErrorStatus';
import { MotifToast } from '@ey-xd/motif-react';
import {
  setRightSideBarOpenClose,
  triggerDnfOpenAiSearch
} from '../../../store/actions/commonActions';
import { publicSources } from '../../../label.constant';
import ConfirmationSourceModal from '../../openAIChat/ChatReply/ConfirmationSourceModal';
import { useNavigate } from 'react-router-dom';

type ISectorChatProps = {
  chatQueryApi?: string;
  handleFocus?: () => void;
  callCombinedReports?: boolean;
  setCallCombinedReports: (value: boolean) => void;
};

const CombinedMarketChat = ({
  chatQueryApi = '',
  handleFocus,
  callCombinedReports,
  setCallCombinedReports
}: ISectorChatProps) => {
  const [seQuery, setSeQuery] = useState<IQuery[]>([]);
  const [queryText, setQueryText] = useState<string>('');
  const [isValidQuery, setIsValidQuery] = useState<boolean>(false);
  const refInput = useRef<HTMLTextAreaElement>(null);
  const refToScroll = useRef<HTMLDivElement>(null);
  const { isClearLoading, chatDataSummmary, isLoading, chunkLoading } = useSelector(
    (state: IStore) => state.userChat
  );
  const userData = useSelector((state: IStore) => state.userProfile?.userData);
  const { isRightSideBarOpen, anySourceSelected, isMRChipActive } = useSelector(
    (state: IStore) => state.common
  );

  const [showDownloadInitiated, setsShowDownloadInitiated] = useState(false);
  const navigate = useNavigate();
  const userChatThreads = useSelector((store: IStore) => store.userChat.chatThreadHistory);
  const selectedChatThread = useSelector((store: IStore) => store.userChat.selectedChatThread);
  const checkedCheckboxes = useSelector((state: any) => state.common?.checkedCheckboxes);
  const eyIPInterRadio = useSelector((state: IStore) => state?.common?.eyIPInterRadio);
  const validURLinputValue = useSelector((state: IStore) => state?.common?.validURLinputValue);
  const lastDeletedThreadID = useSelector((state: IStore) => state?.userChat?.lastDeletedThreadID);
  const [chatLoadCompleted, setChatLoadCompleted] = useState(false);
  const [regeneratedMessageId, setRegeneratedMessageId] = useState(0);
  const [firstResponseTime, setFirstResponseTime] = useState(0);
  const [totalResponseTime, setTotalResponseTime] = useState<number | null>();
  const [controller, setController] = useState<any>(null);
  const [isCompletelyAbortedResposne, setIsCompletelyAbortedResposne] = useState<boolean>(false);
  const [isParitallyAbortedResponse, setIsParitallyAbortedResponse] = useState<boolean>(false);
  const [currentUserChatThreads, setCurrentUserChatThreads] = useState(userChatThreads);
  const [showNotFoundPopup, setShowNotFoundPopup] = useState(false);
  const [questionSummary, setQuestionSummary] = useState('');
  const IsDnfOpenAiSearchTriggered = useSelector(
    (state: IStore) => state.common?.triggerDnfOpenAiSearchValue
  );
  const currentQuestion = useSelector((state: IStore) => state.userChat?.lastQuery);
  const dispatch = useDispatch();
  const fileRegex = new RegExp('relevant_files:', 'i');
  const queryRegex = new RegExp('sqlQuery:', 'i');
  const regexRelevatData = /relevant_files:(.*?)(?=Content:)/s;
  const regexRelevatDataResponseType = /relevant_files:(.*?)(?=ResponseType:)/s;
  const regexContentData = /Content:(.*?)(?=ResponseType:)/s;
  const regexSuggestionData = /suggestions:(.*?)(?=relevant_files:)/s;
  const regexSQLRegex = /sqlQuery:(.*?)(?=suggestions:)/s;
  

  const timeoutError = [
    {
      [RESPONSE_BY.STRATEGY_EDGE]: {
        summary: LABELS.chat_reply.SE_TOKEN_ERROR_MSG,
        content: [],
        responseType: 'error',
        sources: checkedCheckboxes
      }
    }
  ];

  const replyServerError = [
    {
      [RESPONSE_BY.STRATEGY_EDGE]: {
        summary: LABELS.chat_reply.OPENAI_ERROR_MSG,
        content: [],
        responseType: 'error',
        sources: checkedCheckboxes
      }
    }
  ];
  const replyNotFoundError = [
    {
      [RESPONSE_BY.STRATEGY_EDGE]: {
        summary: `\n\n\n${LABELS.chat_reply.MR_EMB_NOT_FOUND_ERROR_MSG}`,
        content: [],
        responseType: 'error',
        sources: checkedCheckboxes
      }
    }
  ];

  useEffect(() => {
    setSeQuery(() => chatDataSummmary?.table);
  }, [chatDataSummmary, chunkLoading]);

  const updateFirstResponseTime = (firstByteTime: any, startTime: number) => {
    if (firstByteTime === null) {
      firstByteTime = performance.now();
      setFirstResponseTime((firstByteTime - startTime) / 1000);
    }
  };

  const updateTotalResponseTime = (startTime: number, isStaticResponse: boolean = false) => {
    if (isStaticResponse) {
      setTotalResponseTime(null);
      return;
    } else {
      const endTime = performance.now(); // Record the end time
      const duration = (endTime - startTime) / 1000; // Calculate the duration
      setTotalResponseTime(duration); // Update state with the response time
    }
  };

  const sendChatQuery = async (summary: string) => {
    setIsCompletelyAbortedResposne(false);
    setIsParitallyAbortedResponse(false);
    scrollToBottom();
    setQuestionSummary(summary);
    let chunks = '';
    let restSummaryPart = '';
    const controller = new AbortController();
    setController(controller);

    const startTime = performance.now();
    let firstByteTime: number | null = null;

    try {
      const summaryData = JSON.stringify({
        query: summary.trim(),
        sources: extractSources(checkedCheckboxes)
      });

      const response: any = await getCIQueryResponse(summaryData, userData, controller);
      const { status, statusText } = response;

      if (controller.signal.aborted) {
        dispatch(
          setChatErrors([
            {
              [RESPONSE_BY.STRATEGY_EDGE]: {
                summary: LABELS.chat_reply.STOP_GENERATION_MSG,
                content: [],
                responseType: 'stop_generation',
                sources: [],
                isCompletelyAbortedResposne: true,
                isParitallyAbortedResponse: false
              }
            }
          ])
        );
        dispatch(toggleLoader(false));
        scrollToBottom();
        setChatLoadCompleted(true);
        return;
      }

      if (
        status === HttpStatusCode.InternalServerError ||
        status === HttpStatusCode.TimedOut ||
        status === HttpStatusCode.BadRequest ||
        statusText === LABELS.SERVER_ERROR
      ) {
        updateFirstResponseTime(firstByteTime, startTime);
        dispatch(setChatErrors([...replyServerError]));
        updateTotalResponseTime(startTime, true);
        dispatch(toggleLoader(false));
        setTimeout(scrollToBottom, 100);
        setChatLoadCompleted(true);
        return;
      }

      if (status === HttpStatusCode.NotFound) {
        updateFirstResponseTime(firstByteTime, startTime);
        dispatch(setChatErrors([...replyNotFoundError]));
        updateTotalResponseTime(startTime, true);
        dispatch(toggleLoader(false));
        setTimeout(scrollToBottom, 100);
        setChatLoadCompleted(true);
        dispatch(triggerDnfOpenAiSearch(false));
        setShowNotFoundPopup(false);
        if (
          checkedCheckboxes.length === 2 &&
          checkedCheckboxes.includes('Market reports') &&
          checkedCheckboxes.includes('Embryonic')
        ) {
          setShowNotFoundPopup(true);
        }
        return;
      }

      updateFirstResponseTime(firstByteTime, startTime);
      const reader = response.body.getReader();
      let isFirstChunk = true;

      const pump = async (): Promise<void> => {
        const { done, value } = await reader.read();
        if (done) {
          dispatch(triggerDnfOpenAiSearch(false));
          setShowNotFoundPopup(false);
          let restChunks: string[] = [];
          const checkboxes = Array.isArray(checkedCheckboxes) ? checkedCheckboxes : [];
          if (restSummaryPart && typeof restSummaryPart === 'string') {
            if (checkboxes.includes('Embryonic')) {
              restChunks = restSummaryPart.split('sqlQuery:');
            } else {
              restChunks = restSummaryPart.split('relevant_files:');
            }
            if (restChunks.length > 1 && restChunks[0].trim()) {
              dispatch(
                setChatSummary(
                  restChunks[0].replace(/sqlQuery:|sqlQuery|sql|'|sql|rel|relevant_files/gi, '')
                )
              );
            }
          }
          updateTotalResponseTime(startTime);
          setChatLoadCompleted(true);
          dispatch(setChunkLoading(false));
          dispatch(setWhoelChatTable(true));
          dispatch(toggleLoader(false));
          scrollToBottom();
          if (chunks && typeof chunks === 'string') {
            setRelevantTableData(chunks);
            setSuggestionsData(chunks);
            handleFinalChatSummary(chunks);
          }
          return;
        }

        const decodedChunks = new TextDecoder().decode(value);
        chunks += decodedChunks;

        dispatch(setChunkLoading(true));

        if (isFirstChunk) {
          dispatch(
            setChatTable([
              {
                SEResponse: {
                  Content: [],
                  Sources: extractSources(checkedCheckboxes),
                  downloadURL: ''
                }
              }
            ])
          );
          if (chunks)
            dispatch(
              setChatSummary(
                decodedChunks.replace(/Summary:|\*\*Summary\*\*:|:|SummaryResponse:/gi, '')
              )
            );
          isFirstChunk = false;
        } else {
          if (checkedCheckboxes.includes('Embryonic')) {
            if (chunks && !chunks.includes('sqlQuery:')) {
              dispatch(
                setChatSummary(
                  decodedChunks
                    .replaceAll(/sqlQuery:|sqlQuery|sql|'|sql|rel|relevant_files/gi, '')
                    .replaceAll("'", '')
                )
              );
              scrollToBottom();
            } else {
              restSummaryPart += decodedChunks;
            }
          } else {
            if (chunks && !chunks.includes('relevant_files:')) {
              if (!decodedChunks.includes('relevant_files:')) {
                dispatch(
                  setChatSummary(
                    decodedChunks
                      .replaceAll(/sqlQuery:|sqlQuery|sql|'|sql|rel|relevant_files/gi, '')
                      .replaceAll("'", '')
                  )
                );
              }
              scrollToBottom();
            } else {
              restSummaryPart += decodedChunks;
            }
          }
        }
        await pump();
      };

      await pump();
    } catch (error) {
      setChatLoadCompleted(true);
      dispatch(setChunkLoading(false));
      if (controller.signal.aborted) {
        dispatch(setChatErrors([...timeoutError]));
        dispatch(toggleLoader(false));
        scrollToBottom();
        updateTotalResponseTime(startTime, true);
      } else {
        dispatch(setChatErrors([...replyServerError]));
        dispatch(toggleLoader(false));
        setChatLoadCompleted(true);
        scrollToBottom();
        updateTotalResponseTime(startTime, true);
      }
    }
  };

  useEffect(() => {
    if (callCombinedReports && IsDnfOpenAiSearchTriggered && currentQuestion) {
      handleSendMessage({} as React.MouseEvent<HTMLElement>, currentQuestion || '');
      dispatch(triggerDnfOpenAiSearch(false));
      setShowNotFoundPopup(false);
      setQueryText('');
      dispatch(lastExecutedMessage(''));
      setCallCombinedReports(false);
    }
  }, [callCombinedReports, IsDnfOpenAiSearchTriggered, currentQuestion]);

  const handleContinueClick = () => {
    setShowNotFoundPopup(false);
    dispatch(triggerDnfOpenAiSearch(true));
    dispatch(lastExecutedMessage(questionSummary));
    setQueryText('');
    setQuestionSummary('');
    dispatch(clearChatHistory());
    dispatch(setLastSavedThreadID(0));
    dispatch(setSelectedChatThread({}));
    if (showNotFoundPopup && checkedCheckboxes && checkedCheckboxes.includes('Market reports')) {
      navigate('/with-marketReports');
    }
  };

  const extractRelevantFilesSection = (input: string, regex: RegExp): string | null => {
    const match = input.match(regex);
    return match ? match[1].trim() : null;
  };

  const setRelevantTableData = (str: string) => {
    try {
      let filesArray: any[] = [];
      let cleanedSection = '';

      // Try main regex first
      const relevantSection = extractRelevantFilesSection(str, regexRelevatData);

      if (relevantSection) {
        cleanedSection = relevantSection
          .replaceAll('```', '')
          .replace(/\n/g, '')
          .replace(/\t/g, '');
      } else if (str.includes('ResponseType:')) {
        // Fallback: check for ResponseType: and use that regex
        const extractedRelevantFiles = extractRelevantFilesSection(
          str,
          regexRelevatDataResponseType
        );
        if (extractedRelevantFiles) {
          cleanedSection = extractedRelevantFiles
            .replaceAll('```', '')
            .replace(/\n/g, '')
            .replace(/\t/g, '');
        } else {
          // If still not found, try splitting with fileRegex
          const splitwiseFiles = str.split(fileRegex);
          if (splitwiseFiles.length > 1) {
            cleanedSection = splitwiseFiles[1]
              .replaceAll('```', '')
              .replace(/\n/g, '')
              .replace(/\t/g, '');
          } else {
            return;
          }
        }
      } else {
        // If no ResponseType: fallback, just split with fileRegex
        const splitwiseFiles = str.split(fileRegex);
        if (splitwiseFiles.length > 1) {
          cleanedSection = splitwiseFiles[1]
            .replaceAll('```', '')
            .replace(/\n/g, '')
            .replace(/\t/g, '');
        } else {
          return;
        }
      }

      try {
        filesArray = JSON.parse(cleanedSection);
      } catch {
        return;
      }
      if (!Array.isArray(filesArray) || filesArray.length === 0) return;

      const updatedRes = filesArray.map((res: any) => ({
        ...res,
        page_number: Array.isArray(res.page_number)
          ? Array.from(new Set(res.page_number))
          : res.page_number
      }));

      dispatch(setRelevantFiles(updatedRes));
    } catch (er: any) {
      return errorStatus(er?.response?.status);
    }
  };

  const setSuggestionsData = (str: string) => {
    try {
      let tableFilesArray: any[] = [];
      let suggestionsArray: any[] = [];
      let sQLLink = '';
      const suggestionSection = extractRelevantFilesSection(str, regexSuggestionData);
      const tableContentSection = extractRelevantFilesSection(str, regexContentData);
      const sqlQuerySection = extractRelevantFilesSection(str, regexSQLRegex);
      const downloadLink = sqlQuerySection?.replaceAll("'", '').trim();

      try {
        if (tableContentSection) {
          tableFilesArray = JSON.parse(tableContentSection);
        }
        if (suggestionSection) {
          suggestionsArray = JSON.parse(suggestionSection);
        }
        if (downloadLink) {
          sQLLink = downloadLink;
        }
      } catch {
        return;
      }

      const linkNSuggestion = {
        sqlQuery: sQLLink,
        suggestions: suggestionsArray,
        Content: tableFilesArray,
        ResponseType: tableFilesArray?.length > 0 ? 'table' : 'answer'
      };
      dispatch(setDownloadNSuggestion(linkNSuggestion));
    } catch (er: any) {
      return errorStatus(er?.response?.status);
    }
  };

  const handleFinalChatSummary = (chunks: string) => {
    const chunksSummary =
      chunks &&
      chunks.split('sqlQuery:')[0].replace(/Summary:|\*\*Summary\*\*:|:|SummaryResponse:/gi, '');
    dispatch(setFinalChatsummary(chunksSummary));
  };

  const handleSendMessage = async (
    ev: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLTextAreaElement>,
    query?: string
  ) => {
    if (!isClearLoading && !isLoading) {
      if ((queryText && queryText.trim().length) || query) {
        const safeQuery = typeof query === 'string' && query.trim().length ? query : queryText;
        dispatch(lastExecutedMessage(safeQuery));
        handleSessionID(selectedChatThread);
        setRegeneratedMessageId(0);
        let newMsg = {
          [RESPONSE_BY.USER]: {
            summary: safeQuery
          }
        };
        dispatch(setChatHistory([newMsg]));
        refToScroll?.current?.scrollIntoView({
          behavior: 'smooth',
          block: 'end'
        });
        sendChatQuery((safeQuery || '').trim());
        setQueryText('');
        dispatch(toggleLoader(true));
        if (Object.keys(selectedChatThread).length === 0 && !localStorage.isSidebarManuallyClosed) {
          dispatch(setRightSideBarOpenClose(true));
        }
      }
    }
  };

  const handleRegenerate = (
    ev: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLTextAreaElement>,
    query?: string
  ) => {
    if (!isClearLoading && !isLoading && anySourceSelected) {
      if ((queryText && queryText.trim().length) || query) {
        handleSessionID(selectedChatThread);
        let newMsg = {
          [RESPONSE_BY.USER]: {
            summary: queryText || query
          }
        };
        setRegeneratedMessageId(
          chatDataSummmary?.table?.[chatDataSummmary?.table?.length - 1]?.SEResponse?.messageId ||
            regeneratedMessageId
        );
        dispatch(regenerateChatSummary([newMsg]));
        dispatch(setChatHistory([newMsg]));
        sendChatQuery((queryText || query || '').trim());
        setQueryText('');
        dispatch(toggleLoader(true));
      }
    }
  };

  const scrollToBottom = () => {
    refToScroll?.current?.scroll({
      left: 0,
      top: refToScroll.current.scrollHeight,
      behavior: 'smooth'
    });
  };

  const handleScrollToBottom = () => {
    scrollToBottom();
  };

  const handleOnChange = (ev: React.ChangeEvent<HTMLTextAreaElement>) => {
    if (checkOnySpecialCharacter(ev.target.value)) setIsValidQuery(false);
    else {
      setIsValidQuery(true);
    }
    setQueryText(ev.target.value);
  };

  useEffect(() => {
    initializeSession();
  }, []);

  useEffect(() => {
    if (seQuery) {
      refInput.current?.focus();
    }
    const timeoutId = setTimeout(() => {
      scrollToBottom();
    }, 100);
    return () => {
      clearTimeout(timeoutId);
    };
  }, [seQuery]);

  const handleKeyDown = async (ev: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (ev.key === 'Enter') {
      ev.preventDefault();
      handleSendMessage(ev);
    }
  };

  useEffect(() => {
    if (chatQueryApi?.length > 0 && Object.keys(selectedChatThread).length === 0) {
      sendChatQuery(chatQueryApi);
    }
  }, [chatQueryApi]);

  useEffect(() => {
    setCurrentUserChatThreads(userChatThreads);
  }, [userChatThreads]);

  useEffect(() => {
    if (lastDeletedThreadID != 0) {
      const updated = userChatThreads.filter((item: any) => item.threadId !== lastDeletedThreadID);
      setCurrentUserChatThreads(updated);
      dispatch(saveUserChatThreadHistory(updated));
      dispatch(setLastDeletedThreadID(0));
    }
  }, [lastDeletedThreadID]);

  const getSourceType = () => {
    let sourceType = '';
    const [embryonic, openAI, marketReports] = publicSources;
    const hasEmbryonic = checkedCheckboxes.includes(embryonic);
    const hasOpenAI = checkedCheckboxes.includes(openAI);
    const hasMarket = checkedCheckboxes.includes(marketReports);
    switch (checkedCheckboxes.length) {
      case 1:
        if (hasMarket) sourceType = RESPONSE_BY.MARKET_REPORT;
        else if (hasEmbryonic) sourceType = RESPONSE_BY.EMBROYNIC;
        else if (hasOpenAI) sourceType = RESPONSE_BY.OPENAI;
        break;
      case 2:
        if (hasMarket && hasEmbryonic) sourceType = RESPONSE_BY.EMBMR;
        else if (hasMarket && hasOpenAI) sourceType = RESPONSE_BY.AIMR;
        else if (hasEmbryonic && hasOpenAI) sourceType = RESPONSE_BY.EMBAI;
        break;
      case 3:
        if (hasMarket && hasEmbryonic && hasOpenAI) sourceType = RESPONSE_BY.EMBAIMR;
        break;
      default:
        break;
    }
    return sourceType;
  };

  const handleDocDownload = async () => {
    dispatch(setDownloadFileMessageWord());
    setsShowDownloadInitiated(true);
    await exportToCombinedDoc(
      seQuery,
      userData.profileImage,
      getSourceType(),
      checkedCheckboxes,
      eyIPInterRadio,
      validURLinputValue
    );
    dispatch(clearDownloadFileMessage());
    saveDownloadChatActivity(getSourceType());
    setTimeout(() => {
      setsShowDownloadInitiated(false);
    }, 1000);
  };

  useEffect(() => {
    if (chatLoadCompleted) {
      saveChatConversation();
    }
  }, [chatLoadCompleted]);

  const saveChatConversation = async () => {
    if (chatDataSummmary?.table?.length === 0) return;
    let requestObject = getComputedRequestObject(
      selectedChatThread,
      regeneratedMessageId,
      chatDataSummmary,
      checkedCheckboxes,
      eyIPInterRadio,
      validURLinputValue,
      firstResponseTime,
      totalResponseTime,
      false,
      isCompletelyAbortedResposne,
      isParitallyAbortedResponse
    );
    const response: any = await saveUserChatHistory(requestObject);
    if (response && response?.threadId) {
      if (response.threadId !== selectedChatThread?.threadId) {
        setThreadsUnSelected(currentUserChatThreads);
        handleUserChatThreadHistory(
          requestObject,
          response.threadId,
          currentUserChatThreads,
          userData,
          dispatch
        );
      }
    }
    setRegeneratedMessageId(response?.messageId);
    setChatLoadCompleted(false);
  };

  const handleStopGeneration = () => {
    controller.abort();
    setIsCompletelyAbortedResposne(false);
    setIsParitallyAbortedResponse(false);
    if (chunkLoading) {
      setIsParitallyAbortedResponse(true);
      let lastChatData =
        chatDataSummmary?.table[chatDataSummmary?.table?.length - 1]?.SEResponse || undefined;
      if (lastChatData) {
        if (
          !('isCompletelyAbortedResposne' in lastChatData) &&
          !('isParitallyAbortedResponse' in lastChatData)
        ) {
          lastChatData.isCompletelyAbortedResposne = false;
          lastChatData.isParitallyAbortedResponse = true;
        }
      }
      setChatLoadCompleted(true);
    } else {
      setIsCompletelyAbortedResposne(true);
    }
  };

  const getResponseFlag = (SEResponse: any, flag: string) => {
    if (flag in SEResponse) {
      return SEResponse[flag];
    } else {
      return false;
    }
  };

  return (
    <>
      <div
        className={`combined-market ${isRightSideBarOpen && 'combined-market-block'}   ${isMRChipActive && 'mrWidth'}`}>
        <div
          ref={refToScroll}
          className={`combined-market__scroll-container ${seQuery?.length > 0 && 'scroll-height'}`}>
          {seQuery?.map((chat: IQuery, ind: number) => {
            const { user, SEResponse } = chat;
            return (
              <React.Fragment key={ind}>
                {showDownloadInitiated && (
                  <MotifToast
                    className={'combined-market__toast-container-public'}
                    variant='info'
                    actionName=''
                    position='bottom'
                    onClose={() => {
                      setsShowDownloadInitiated(false);
                    }}>
                    <div>Downloading</div>
                  </MotifToast>
                )}
                {user && (
                  <SendMessage
                    key={ind}
                    message={user}
                    isNew={true}
                    userQueryWithResponse={chat}
                    loader={isLoading}
                    chatData={{ SEResponse }}
                    handleSendMessage={handleSendMessage}
                  />
                )}

                {SEResponse && (
                  <ChatReply
                    message={user?.summary}
                    chatData={{ SEResponse }}
                    key={ind.toString() + '__strctrd-se-chats'}
                    isNew={true}
                    isSE={true}
                    messageLoading={isLoading}
                    chunkLoading={chunkLoading}
                    isLastItem={ind === seQuery.length - 1}
                    isMarketReports={true}
                    isCombined={true}
                    handleSendMessage={handleSendMessage}
                    scrollToBottom={handleScrollToBottom}
                    handleRegenerate={handleRegenerate}
                    isCompletelyAbortedResposne={getResponseFlag(
                      SEResponse,
                      'isCompletelyAbortedResposne'
                    )}
                    isParitallyAbortedResponse={getResponseFlag(
                      SEResponse,
                      'isParitallyAbortedResponse'
                    )}
                  />
                )}
              </React.Fragment>
            );
          })}
          {isLoading && !chunkLoading && <ChatReply loader={isLoading} isNew={true} isSE={true} />}
          <div className='stop-generation-container'>
            {(isLoading || chunkLoading) && (
              <button onClick={handleStopGeneration} className='combine-stop-generation-button'>
                <img src={stopChatIcon} alt='Stop' className='combine-stop-icon' /> Stop Generating
              </button>
            )}
          </div>
        </div>
      </div>
      <div className='combined-market__input-container'>
        <InputBox
          selectedSegment={true}
          queryText={queryText}
          refInput={refInput}
          hasQueries={seQuery?.length > 0}
          handleOnChange={handleOnChange}
          handleResetMessage={() => {}}
          handleSendMessage={handleSendMessage}
          handleKeyDown={handleKeyDown}
          disabled={isLoading}
          handleOnFocus={handleFocus}
        />
        <div className='combined-market__download-btn-box'>
          <LinkButton onClick={() => handleDocDownload()} disabled={isLoading || isClearLoading}>
            <img src={downloadImg} /> &nbsp;
            <span className='combined-market__download-text'>Download Chat</span>
          </LinkButton>
        </div>
      </div>
      {showNotFoundPopup && (
        <ConfirmationSourceModal
          show={showNotFoundPopup && !isLoading}
          handleContinueClick={() => handleContinueClick()}
          handleNoClick={() => setShowNotFoundPopup(false)}
        />
      )}
    </>
  );
};

export default CombinedMarketChat;
